__webpack_require__.p = "https://www.memory-comic.com/packs/";